import React, { useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { userLogin } from '../store/slices/mainSlices'
import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import Login from './login'
import Header from './header'
import Footer from './footer'
import Aside from '../components/aside'

export default function Router() {
  const { language } = useParams()
  const { i18n } = useTranslation()
  const dispatch = useDispatch()

  const login = useSelector(state => state.mainReducer.userLogin)

  useEffect(() => {
    if (localStorage.userLogin || localStorage.userLogin === 'false') {
      dispatch(userLogin(true))
    } else {
      dispatch(userLogin(false)) //Edit to false for activate login page
    }
  }, [login, dispatch])

  useEffect(() => {
    const changeLanguage = language => {
      i18n.changeLanguage(language)
    }
    if (language === 'ru') {
      changeLanguage('ru')
    }
    if (language === 'en') {
      changeLanguage('en')
    }
  }, [language, i18n])

  const verification = login ? (
    <>
      <Header />
      <main className='mainHome'>
        <Aside />
        <section className='mainSection'>
          <div className='border'>
            <Outlet />
          </div>
        </section>
      </main>
      <Footer />
    </>
  ) : (
    <Login />
  )
  return verification
}
